import { FC } from 'react';
import { Rating } from '@mui/material';
import { ButtonOutlinePrimary, Icon } from '@lambdacurry/component-library';
import { Card, CardContent, MealImage } from 'lib/components';
import { MyOrdersQuery } from 'lib/home/generated/types/api';
import { EditRatingButton, RatingInfoProps } from '../';
import { Loading } from '..';

export interface ProductRatingProps {
  lineItem: MyOrdersQuery['customerOrders'][number]['cart']['items'][number];
  setRatingModal: (props: { isOpen: boolean; ratingInfo: RatingInfoProps }) => void;
  orderId: string;
  index: number;
}

export const ProductRating: FC<ProductRatingProps> = ({ lineItem, setRatingModal, orderId }) => {
  if (!lineItem) return <Loading />;

  const { id, thumbnail, title, product_rating, quantity } = lineItem;

  const ratingInfo: RatingInfoProps = {
    title,
    medusa_line_item_id: id,
    medusa_order_id: orderId,
    variant_id: lineItem?.variant_id,
    variant_preference: lineItem?.variant?.variant_preference,
    rating: product_rating?.rating.toString(),
    note: product_rating?.note
  };

  return (
    <Card data-cy="product-rating" className="bg-inherit px-4 pb-4">
      <CardContent className="!p-0">
        <div className="flex justify-between items-top flex-wrap">
          <div className="flex mb-4 flex-wrap">
            <div className="overflow-hidden w-24 sm:w-16 mr-4 mb-2">
              <MealImage url={thumbnail} title={title} />
            </div>
            <div className="mr-4 !max-w-[350px]">
              {title}
              {quantity > 1 && <div className="text-gray-500">QTY:{quantity}</div>}
            </div>
          </div>
          {!product_rating?.rating ? (
            <ButtonOutlinePrimary
              className="w-full sm:w-auto"
              type="submit"
              data-cy="add-rating"
              onClick={() => setRatingModal({ isOpen: true, ratingInfo })}
            >
              <Icon className="text-gray-300" name="star" />
              Review
            </ButtonOutlinePrimary>
          ) : (
            <div className="flex justify-between items-center md:items-start w-full md:w-auto">
              <Rating name="read-only" value={product_rating?.rating} readOnly />
              <div className="md:hidden">
                <EditRatingButton onClick={() => setRatingModal({ isOpen: true, ratingInfo })} />
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="flex justify-between content-between items-center">
            {product_rating?.rating && (
              <div className="hidden sm:show">
                <EditRatingButton onClick={() => setRatingModal({ isOpen: true, ratingInfo })} />
              </div>
            )}
          </div>
        </div>

        {product_rating?.rating && (
          <div className="flex justify-between content-between items-center">
            <p data-cy="rating-note-view" className="text-gray-500 my-1">
              {product_rating?.note}
            </p>
            {product_rating?.rating && (
              <div className="hidden md:block">
                <EditRatingButton onClick={() => setRatingModal({ isOpen: true, ratingInfo })} />
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
